import { axiosBaseQuery } from "@/shared/api/base-services-axios-rtx";
import { createQuery } from "@/shared/helpers/create-query.helper";
import { exportToExcel } from "@/shared/helpers/export-file-xlsx.helper";
import { ReportsEndpoints } from "@/shared/models/endpoints/reports.endpoint";
import {
  MonthlyClosureData,
  MonthlyClosureDate
} from "@/shared/models/interfaces/response/reports/monthly-closure.interface";
import { ExtendPropertiesReport } from "@/shared/models/interfaces/response/reports/property-report.response";
import { ISalesPerReportReponse } from "@/shared/models/interfaces/response/reports/sales-per-report.response";
import { IUserReportResponse } from "@/shared/models/interfaces/response/reports/user-report.response";
import { ExportPropertyReportsValuesQRTK } from "./values/property-report-export.values";
import { PropertyReportsValuesQRTK } from "./values/property-report.values";
import { ExportUserReportsValuesQRTK } from "./values/user-report-export.values";
import { UserReportsValuesQRTK } from "./values/user-report.values";
import { MonthlyReportsValuesQRTK } from "./values/monthy-report.values";
import { SalesReportsValuesQRTK } from "./values/sales-report.values";
import { ExportSalesReportsValuesQRTK } from "./values/sales-report-export.values";
import { AgenciesReportsValuesQRTK } from "./values/agencies-report.values";
import { IAgenciesReportResponse } from "@/shared/models/interfaces/response/reports/agencies-report.response";
import { AgenciesReportsExportValuesQRTK } from "./values/agencies-report-export.values";
import { ClientsReportsValuesQRTK } from "./values/clients-report.values";
import { IClientsReportResonse } from "@/shared/models/interfaces/response/reports/clients-report.response";
import { ClientsReportsExportValuesQRTK } from "./values/clients-report-export.values";
import { ICommissionsReportResponse } from "@/shared/models/interfaces/response/reports/commissions-report.response";
import { CommissionsReportsValuesQRTK } from "./values/commissions-report.values";
import { CommissionsReportsExportValuesQRTK } from "./values/commissions-report-export.values";
import { CommissionsReportsGroupExportValuesQRTK } from "./values/commissions-report-group-export.values";
import { CommissionsReportsGroupValuesQRTK } from "./values/commissions-group-report.values";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ReportsQueryServices = createApi({
  reducerPath: "reports-query",
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    getSalesReport: builder.mutation({
      query: (v: SalesReportsValuesQRTK) => ({
        url: ReportsEndpoints.GetReports + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: ISalesPerReportReponse, meta, arg) => {
        return response;
      }
    }),
    exportSalesReport: builder.mutation({
      query: (v: ExportSalesReportsValuesQRTK) => ({
        url: ReportsEndpoints.GetReports + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    getMonthlyClosure: builder.mutation({
      query: (v: MonthlyReportsValuesQRTK) => ({
        url: ReportsEndpoints.GetReportsMonthly + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: MonthlyClosureData[], meta, arg) => {
        return {
          message: "ok",
          data: response
        };
      }
    }),
    getDateReport: builder.mutation({
      query: () => ({
        url: ReportsEndpoints.GetDate,
        method: "GET"
      }),
      transformResponse: (response: MonthlyClosureDate, meta, arg) => {
        return response.data;
      }
    }),
    getMonthlyClosureExport: builder.mutation({
      query: (v: MonthlyReportsValuesQRTK) => ({
        url: ReportsEndpoints.GetReportsMonthlyExport + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    getPropertyReports: builder.mutation({
      query: (v: PropertyReportsValuesQRTK) => ({
        url: ReportsEndpoints.extendReportProperty + createQuery(v.query),
        method: "GET",
        timeOut: 300000
      }),
      transformResponse: (response: ExtendPropertiesReport, meta, arg) => {
        return response;
      }
    }),

    exportPropertyReports: builder.mutation({
      query: (v: ExportPropertyReportsValuesQRTK) => ({
        url: ReportsEndpoints.extendReportPropertyDowload + createQuery(v.query),
        method: "GET",

        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        exportToExcel(response, "Reporte de propiedades", "csv");
        return response;
      }
    }),

    getUserReports: builder.mutation({
      query: (v: UserReportsValuesQRTK) => ({
        url: ReportsEndpoints.reportUser + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: IUserReportResponse, meta, arg) => {
        return response;
      }
    }),
    exportUserReports: builder.mutation({
      query: (v: ExportUserReportsValuesQRTK) => ({
        url: ReportsEndpoints.reportUser + createQuery(v.query),
        method: "GET",
        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        exportToExcel(response, "Reporte de usuarios");
        return response;
      }
    }),

    getAgenciesReport: builder.mutation({
      query: (v: AgenciesReportsValuesQRTK) => ({
        url: ReportsEndpoints.reportAgencies + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: IAgenciesReportResponse, meta, arg) => {
        return response;
      }
    }),
    exportgenciesReport: builder.mutation({
      query: (v: AgenciesReportsExportValuesQRTK) => ({
        url: ReportsEndpoints.reportAgencies + createQuery(v.query),
        method: "GET",
        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        exportToExcel(response, "Reporte de agencias");
        return response;
      }
    }),
    getClientsReport: builder.mutation({
      query: (v: ClientsReportsValuesQRTK) => ({
        url: ReportsEndpoints.reportClients + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: IClientsReportResonse, meta, arg) => {
        return response;
      }
    }),
    exportClientsReport: builder.mutation({
      query: (v: ClientsReportsExportValuesQRTK) => ({
        url: ReportsEndpoints.reportClients + createQuery(v.query),
        method: "GET",
        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        exportToExcel(response, "Reporte de clientes");
        return response;
      }
    }),
    getCommisionsReport: builder.mutation({
      query: (v: CommissionsReportsValuesQRTK) => ({
        url: ReportsEndpoints.reportCommission + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: ICommissionsReportResponse, meta, arg) => {
        return response;
      }
    }),
    exportCommisionsReport: builder.mutation({
      query: (v: CommissionsReportsExportValuesQRTK) => ({
        url: ReportsEndpoints.reportCommission + createQuery(v.query),
        method: "GET",
        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    }),
    getCommisionsReportGroup: builder.mutation({
      query: (v: CommissionsReportsGroupValuesQRTK) => ({
        url: ReportsEndpoints.reportCommissionGroup + createQuery(v.query),
        method: "GET"
      }),
      transformResponse: (response: ICommissionsReportResponse, meta, arg) => {
        return response;
      }
    }),
    exportCommisionsReportGroup: builder.mutation({
      query: (v: CommissionsReportsGroupExportValuesQRTK) => ({
        url: ReportsEndpoints.reportCommissionGroup + createQuery(v.query),
        method: "GET",
        responseType: "arraybuffer"
      }),
      transformResponse: (response: any, meta, arg) => {
        return response;
      }
    })
  })
});

export const {
  useGetSalesReportMutation,
  useGetDateReportMutation,
  useGetMonthlyClosureMutation,
  useGetMonthlyClosureExportMutation,
  useGetPropertyReportsMutation,
  useGetUserReportsMutation,
  useExportUserReportsMutation,
  useExportPropertyReportsMutation,
  useExportSalesReportMutation,
  useGetAgenciesReportMutation,
  useExportgenciesReportMutation,
  useGetClientsReportMutation,
  useExportClientsReportMutation,
  useGetCommisionsReportMutation,
  useExportCommisionsReportMutation,
  useGetCommisionsReportGroupMutation,
  useExportCommisionsReportGroupMutation
} = ReportsQueryServices;
